module.exports = __webpack_public_path__ + "img/missing_post.0f378eea.svg";